import { useQuery, useMutation } from '@tanstack/react-query';

import * as folderServices from 'services/folder';
import { getSubMappingSubscription } from 'services/mapping';

export const getFolderDownloadSettingKey = (folderId) => {
  return ['folder', 'latest-download-setting', +folderId];
};

export const queryLatestDownloadSetting = async ({ queryKey }) => {
  const folderId = queryKey[2];

  const response = await folderServices.getDownloadSetting({ id: folderId });

  if (response.isSuccess) {
    return response?.data;
  }
};

export const useFolderDownloadSettingQuery = (props) => {
  const { folderId, ...restProps } = props;

  return useQuery({
    queryKey: getFolderDownloadSettingKey(folderId),
    queryFn: queryLatestDownloadSetting,
    ...restProps,
  });
};

//* PRODUCT MAPPING

export const getFolderDownloadProductMappingKey = (mappingId) => {
  return ['folder', 'product-mapping', +mappingId];
};

const queryFolderDownloadProductMapping = async ({ queryKey }) => {
  const mappingId = queryKey[2];

  const params = {
    pageIndex: 1,
    pageSize: 9999,
    filters: [
      {
        fieldName: 'id',
        filterType: 'Equal',
        value: mappingId,
      },
    ],
    enableRivirDownload: true,
  };

  const response = await getSubMappingSubscription(params);

  if (response?.isSuccess) {
    return response.data?.gridData?.[0];
  }
};

export const useFolderDownloadProductMappingQuery = (props) => {
  const { mappingId, ...restProps } = props;

  return useQuery({
    queryKey: getFolderDownloadProductMappingKey(mappingId),
    queryFn: queryFolderDownloadProductMapping,
    ...restProps,
  });
};

export const getFolderDownloadScheduleKey = (folderId) => {
  return [
    'folder',
    'latest-schedule-download',
    folderId ? +folderId : null,
  ].filter(Boolean);
};

export const getManageScheduleDownloadKey = (id) => {
  return {
    all: ['folder', 'manage-schedule'],
    get list() {
      return [...this.all, 'get-all-folder-schedules', id ? +id : null].filter(
        Boolean
      );
    },
    get detail() {
      return [...this.all, 'get-detail-folder-scheduler', id ? +id : null];
    },
  };
};

export const queryLatestScheduleDownloadSetting = async ({ queryKey }) => {
  const folderId = queryKey[2];

  if (!folderId) return null;

  const response = await folderServices.getScheduleDownloadSetting({
    id: folderId,
  });

  if (response.isSuccess) {
    return response?.data;
  }
};

export const queryFolderScheduleDownload = async ({ queryKey }) => {
  const folderId = queryKey[3];

  if (!folderId) return null;

  const response = await folderServices.getFolderScheduleDownload({
    folderId,
  });

  if (response?.isSuccess) {
    return response?.data;
  }
};
export const queryFolderScheduleDownloadDetail = async ({ queryKey }) => {
  const id = queryKey[3];

  if (!id) return null;

  const response = await folderServices.getFolderScheduleDownloadDetail({
    id,
  });

  if (response?.isSuccess) {
    return response?.data;
  }
};

export const useFolderDownloadScheduleQuery = (props) => {
  const { folderId, ...restProps } = props;

  return useQuery({
    queryKey: getFolderDownloadScheduleKey(folderId),
    queryFn: queryLatestScheduleDownloadSetting,
    ...restProps,
  });
};

export const useManageScheduleDownloadQuery = (props) => {
  const { folderId, ...restProps } = props;

  return useQuery({
    queryKey: getManageScheduleDownloadKey(folderId).list,
    queryFn: queryFolderScheduleDownload,
    ...restProps,
  });
};

export const useGetScheduleDownloadDetailQuery = (props) => {
  const { scheduleId, ...restProps } = props;

  return useQuery({
    queryKey: getManageScheduleDownloadKey(scheduleId).detail,
    queryFn: queryFolderScheduleDownloadDetail,
    ...restProps,
  });
};
